



























































































import { Vue, Component, Watch } from "vue-property-decorator";
import {
  TestAnswerCreate as ITestAnswerCreate,
  TestQuestionCreate as ITestQuestionCreate
} from "@/api/models";
import CustomButton from "@/components/form/CustomButton.vue";
import { addQuestion } from "@/components/tests/testMethods";

@Component({ components: { CustomButton } })
export default class TestQuestionBufferForm extends Vue {
  parseQuestions: Array<ITestQuestionCreate> = [];
  bufferData: string = `${this.$tc(
    this.$translate.ThisIsTheFirstParagraphOfTheQuestion
  )}
${this.$tc(this.$translate.SecondParagraphOfTheQuestion)}
${this.$tc(this.$translate.AnswerDesc)}
${this.$tc(this.$translate.CorrectAnswerCommentOnTheAnswer)}

${this.$tc(this.$translate.PushkinWasBornIn)}
*+ 1799
*2001
*1984
${this.$tc(this.$translate.YesterdayDesc)}

`;

  @Watch("bufferData", { immediate: true })
  checkBuffer() {
    this.parseBuffer();
  }

  checkComment(val: string) {
    return val.split("///")[val.length - 1].trim();
  }

  parserAnswer(value: string) {
    let body;
    let comment = "";

    if (value.includes("///")) {
      [body, comment] = value.split("///");
    } else {
      body = value;
    }

    return {
      body: body.trim(),
      comment: comment.trim()
    };
  }

  parseBuffer() {
    this.parseQuestions = [];
    const answersParser = (
      strings: Array<string>
    ): Array<ITestAnswerCreate> => {
      let result: Array<ITestAnswerCreate> = [];
      strings.forEach(el => {
        this.parserAnswer(el);
        const _body = this.parserAnswer(el).body;
        const _comment = this.parserAnswer(el).comment;

        if (el.substr(1)[0] === "+") {
          result.push({
            body: _body.substr(2).trim(),
            value: true,
            comment: _comment
          });
        } else {
          result.push({
            body: _body.substr(1).trim(),
            value: false,
            comment: _comment
          });
        }
      });
      return result;
    };
    if (this.bufferData.includes("***")) {
      this.bufferData
        .replace(/^\s*\n/gm, "")
        .split("***")
        .forEach(el => {
          if (el.length) {
            el = el.trim();
            let body = "";
            let answersStr: Array<string> = [];
            let answers: Array<ITestAnswerCreate>;
            el.split("\n").forEach(el => {
              el = el.trim();
              el[0] === "*"
                ? answersStr.push(el)
                : answersStr.length === 0
                ? (body += `<p>${el}</p>`)
                : null;
            });
            answers = answersParser(answersStr);
            this.parseQuestions = [
              ...this.parseQuestions,
              {
                body: body,
                answers: answers
              }
            ];
          }
        });
    }
  }

  generateFromBuffer() {
    if (this.parseQuestions.every(addQuestion)) {
      this.$emit("addQuestions", this.parseQuestions);
      this.$emit("cancel");
    }
  }

  goto() {
    //@ts-ignore
    this.$refs.testFormHeader.scrollIntoView({
      block: "start",
      inline: "nearest",
      behavior: "smooth"
    });
    // window.scrollBy(0, -4);
  }

  mounted() {
    this.goto();
  }
}
